import { render, staticRenderFns } from "./FileSubmitModal.vue?vue&type=template&id=610a02d2&"
import script from "./FileSubmitModal.vue?vue&type=script&lang=js&"
export * from "./FileSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./FileSubmitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports